import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from '@getro/rombo';

export const CustomFieldBadge = ({ children }) => (
  <Tag
    sx={{
      flex: '0 0 auto',
      pl: '8px',
      pr: '8px!important',
      py: '2px',
      height: 'auto',
      mr: 0,
      '&& > div': {
        fontSize: '10px',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '1px',
      },
    }}
  >
    {children}
  </Tag>
);

CustomFieldBadge.propTypes = {
  children: PropTypes.node.isRequired,
};
